module.exports = __webpack_public_path__ + "static/media/twitter.aa4b502c.svg";